query eventSubscription($id: UUID!) {
  event: eventByEventId(eventId: $id) {
    eventId
    core: bookedEventsByEventId {
      totalCount
      nodes {
        pricingMode
        isOfferedLive
        isOfferedPreMatch
      }
    }
    sameGameParlays: sgpBookedEventsByEventId {
      totalCount
      nodes {
        isOfferedLive
        isOfferedPreMatch
      }
    }
    playerProps: playerPropsBookedEventsByEventId {
      totalCount
      nodes {
        isOfferedLive
        isOfferedPreMatch
      }
    }
    micro: microBookedEventsByEventId {
      totalCount
      nodes {
        isOfferedLive
        isOfferedPreMatch
      }
    }
    competition {
      feedConfigurations: competitionFeedConfigurationsByCompetitionId {
        nodes {
          marketCategories
        }
      }
    }
  }
}
